export default {
    'R': []
}